import { createApiClient } from "@skilitics/publish-endpoint-definitions";

import { getRequiredAppSetting } from "../shared/index.ts";
import { attachAuthorizationMiddleware } from "./infrastructure/index.ts";

const endpoint = getRequiredAppSetting(import.meta.env.REACT_APP_DISTRIBUTION_ENDPOINT, "DISTRIBUTION_ENDPOINT");

export const distributionPublishApiClient = createApiClient(endpoint);

attachAuthorizationMiddleware(distributionPublishApiClient.axios);

export const useDistributionPublishApiClient = () => distributionPublishApiClient;
